import { parseSeries } from "views/logic/aggregationbuilder/Series";
const getFieldNameFromTrace = ({ series, fullPath }) => {
  if (!fullPath) return null;
  const desireSeries = series.find((s) => {
    var _a;
    const nameToFInd = (_a = s.config.name) != null ? _a : s.function;
    return fullPath.endsWith(nameToFInd);
  });
  if (!desireSeries) return null;
  return parseSeries(desireSeries.function).field;
};
export default getFieldNameFromTrace;
